import classNames from "classnames";
import React from "react";

function TabBar({ tabs, handleActiveTab, activeTab, isPetProfile, className }) {
  return (
    <>
      <div
        className={classNames(
          "mb-[1.25rem]",
          { "flex justify-between ": isPetProfile },
          { "grid grid-cols-6 ": !isPetProfile },
          className
        )}
      >
        {tabs.length > 0 &&
          tabs.map((tab) => (
            <div
              key={tab.id}
              className="text-center px-2 cursor-pointer"
              onClick={() => handleActiveTab(tab.value)}
            >
              <h3
                className={`${activeTab === tab.name ? "text-[#E91F63]" : ""}`}
              >
                {tab.label}
              </h3>
            </div>
          ))}
      </div>
      <div
        className={classNames("h-[3px] w-full bg-[#ECF1F4]", {
          "grid grid-cols-2": isPetProfile,
          "mb-[2rem] grid grid-cols-6": !isPetProfile,
        })}
      >
        {tabs.length > 0 &&
          tabs.map((tab) => (
            <div
              key={tab.id}
              className={`${activeTab === tab.value && "bg-[#E91F63]"}`}
            ></div>
          ))}
      </div>
    </>
  );
}

export default TabBar;
